import { render, staticRenderFns } from "./veSbzcJzwInfoShow.vue?vue&type=template&id=427b23e1&scoped=true"
import script from "./veSbzcJzwInfoShow.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwInfoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b23e1",
  null
  
)

export default component.exports